module.exports = __webpack_public_path__ + "static/media/lettering.35578ab0.gif";